import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, NgModel } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Params, Route, Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import { SearchActions } from 'src/app/common/store/actions/search.actions';
import { selectAllCarImagesFolders, selectAllSearchedCars, selectAllSearchedCarsCount, selectAllSearchedCarsPreviewTotalCount, selectDealerFavorites, selectSearchCriteria, selectSearchFetchingResults } from 'src/app/common/store/state/app.state';
import { AppConstants } from 'src/app/public/common/constants/app-constants';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { CarSearchCriteriaComponent } from '../car-search-criteria/car-search-criteria.component';
import { CarCardListComponent } from '../car-card-list/car-card-list.component';
import { AsyncPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FileData } from 'src/app/public/common/models/file-data.model';
import { CarCriteria } from '../../models/car-criteria.model';
import { Car } from '../../models/car.model';


@Component({
    selector: 'app-car-search',
    templateUrl: './car-search.component.html',
    styleUrls: ['./car-search.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatSelectModule, MatIconModule, CarSearchCriteriaComponent, CarCardListComponent, AsyncPipe]
})
export class CarSearchComponent implements OnInit {

  @Input() businessLine?: CarBusinessLine;
  
  previewTotalCount$: Observable<number>;
  searchCriteria$: Observable<CarCriteria>;

  fetchingResults$: Observable<boolean>;

  carResults$: Observable<Car[]>;
  carResults: Car[] = [];

  count$: Observable<number>;

  carImagesFolders$: Observable<Map<string, Array<FileData>>>;

  carCriteria: CarCriteria = new CarCriteria();
  pageNumber: number = 0;
  pageSize: number = AppConstants.PAGE_SIZE_DEFAULT;
  pageNumbers: number [] = [ 1 ];

  totalItems: number = 0;
  pageSizeOptions = AppConstants.PAGE_SIZE_OPTIONS;

  carsFetched: boolean = false;
  parameters?: Params;

  CarBusinessLine = CarBusinessLine;

  constructor(

    private store: Store, 
    route: ActivatedRoute,
    router: Router
    ) {

      this.fetchingResults$ = store.select(selectSearchFetchingResults);

      this.searchCriteria$ = store.select(selectSearchCriteria);
      this.previewTotalCount$ = store.select(selectAllSearchedCarsPreviewTotalCount);

      this.carResults$ = store.select(selectAllSearchedCars);
      this.count$ = store.select(selectAllSearchedCarsCount);

      this.carImagesFolders$ = store.select(selectAllCarImagesFolders);

      this.searchCriteria$.subscribe(criteria => {
        this.carCriteria = criteria;
        this.pageSize = this.carCriteria.pageSize;
        this.pageNumbers = Array(Math.ceil(this.totalItems/this.carCriteria.pageSize)).fill(0).map((x,i)=>i);
      });

      route.queryParams.subscribe(params => {

        //let temp = JSON.parse(JSON.stringify(params));
        console.log("params = "+JSON.stringify(params));
        console.log("biz line  = "+this.businessLine);
        this.parameters = params;

        //let temp = Object.assign(new CarCriteria(), params);
        let crt: CarCriteria = new CarCriteria();
        AppFunctions.replaceValues(crt, params);

        console.log("criteria 1= "+JSON.stringify(crt));

        
        //crt.businessLine = this.businessLine!
        

        
        //this.store.dispatch(SearchActions.searchPreviewCriteriaSubmit({carCriteria: crt}));
        if(this.businessLine != undefined){
          
          crt.businessLine = this.businessLine!;
          console.log("criteria 2 = "+JSON.stringify(crt));
          store.dispatch(SearchActions.searchCriteriaSubmit({carCriteria: crt}));
          this.carsFetched = true;
        } else{
          this.carsFetched = false;
        }
          
        /*
        if(JSON.stringify(params) === "{}"){
          console.log("params is empty");
          temp = JSON.parse(JSON.stringify(this.carCriteria));
          router.navigate(
            ['/buy-car/search'],
            { queryParams: temp }
          );

        }else{
          this.store.dispatch(SearchActions.searchCriteriaSubmit({carCriteria: temp}));  
          this.store.dispatch(SearchActions.searchPreviewCriteriaSubmit({carCriteria: temp}));
        }
        */
      });

    }

    ngOnInit() {
      //this.cars$.subscribe(val => {
        
      //});

      this.previewTotalCount$.subscribe(total => {
        this.totalItems = total;
        //this.pageNumbers = Array(Math.ceil(this.totalItems/this.carCriteria.pageSize)).fill(0).map((x,i)=>i);
      });

      if(!this.carsFetched){
        
        //let crt: CarCriteria = JSON.parse(JSON.stringify(this.carCriteria));
        let crt: CarCriteria = new CarCriteria();
        AppFunctions.replaceValues(crt, this.parameters);
        crt.businessLine = this.businessLine!;

        console.log("criteria 22 = "+JSON.stringify(crt));
        this.store.dispatch(SearchActions.searchCriteriaSubmit({carCriteria: crt}));
        this.carsFetched = true;

      } 

      this.carResults$.subscribe(
        (res: Car[]) =>  {
          this.carResults = res.map(c => Object.assign(new Car(), c));
        }
      );
  }

  loadPreviousPage(){
    if(this.pageNumber > 0){
      this.pageNumber --;
      this.dispatchEvent();
    }
    
  }

  loadNextPage(){
    if(this.pageNumber < this.totalItems/this.pageSize - 1){
      this.pageNumber ++;
      this.dispatchEvent();
    } 
  }

  loadPage(pgNum: number){

      this.pageNumber = pgNum;
      this.dispatchEvent();
    
  }

  updatePageSize(){
    this.pageNumber = 0;
    this.dispatchEvent();
  }
  
  dispatchEvent(){

    let crt = JSON.parse(JSON.stringify(this.carCriteria));
    crt.pageSize = this.pageSize;
    crt.pageNumber = this.pageNumber;
    this.store.dispatch(SearchActions.searchCriteriaSubmit({carCriteria: crt}));
  }
  
}
